/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const publishDataSchema = z.object({
  published: z.number(),
  collectionSlug: z.string().optional(),
});

export const publishCollectionChallengesResponseSchema = createApiResponseSchema(
  publishDataSchema,
) as z.ZodSchema<IAPI<{ published: number; collectionSlug?: string }>>;

export type IPublishCollectionChallengesResponse = IAPI<{
  published: number;
  collectionSlug?: string;
}>;
